<template>
  <div>
    <navbar back fixed>
      <span slot="title">业务办理流程</span>
    </navbar>
    <div class="page-content">
      <scroller ref="scroller">
        <div class="process">
          <h1 class="title">办理流程</h1>
          <div class="wraper-process">
            <div class="inner-process">
              <div class="num">1</div>
              <h3 class="inner-title">提交借款订单申请</h3>
              <div class="inner-txt">
                访问91weijia.com或关注官方微信号，在首页现在产品进入产品介绍页面，点击“立即申请”，进入贷款申请页面，填写贷款金额、贷款期限后，点击“提交订单”即可完成借款订单提交。
              </div>
            </div>
            <div class="inner-process">
              <div class="num">2</div>
              <h3 class="inner-title">完善个人信息</h3>
              <div class="inner-txt">
                点击“我的”，找到已提交的借款订单，点击“完善收款信息”进入个人信息补充页面。完成实名认证及收款卡信息的录入。点击“确认”提交即可。
              </div>
            </div>
            <div class="inner-process">
              <div class="num">3</div>
              <h3 class="inner-title">线下实地考察</h3>
              <div class="inner-txt">
                在完成个人信息录入后，伟嘉安捷贷款专员会第一时间联系您，确定相关贷款细节，并协助您办理相关资料及公证等。
              </div>
            </div>
            <div class="inner-process">
              <div class="num">4</div>
              <h3 class="inner-title">风控审核</h3>
              <div class="inner-txt">
                在贷款资料准备完成后，提交贷款资料，由伟嘉安捷风控团队进行风控审核。
              </div>
            </div>
            <div class="inner-process">
              <div class="num">5</div>
              <h3 class="inner-title">放款</h3>
              <div class="inner-txt">
                在风控审核通过后，即可请求放款。
              </div>
            </div>
          </div>
        </div>
      </scroller>
    </div>
  </div>
</template>

<script>
  import Navbar from 'components/navbar/navbar'
  import Scroller from 'components/scroller/scroller'

  export default {
    mounted () {
      this.$nextTick(() => {
        if (this.$refs.scroller) {
          setTimeout(() => {
            this.$refs.scroller.resize()
          }, 500)
        }
      })
    },
    components: {Navbar, Scroller}
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../common/css/mixmin'

  .page-content
    background-color #1b446a
    background-image url(../../../static/images/bg-main.png)
    background-repeat repeat

    .process
      padding 0 1em
      font-size px2rem(26)
      color #b9d5ee
      line-height 1.4

      .title
        display inline-block
        margin px2rem(26) 0 px2rem(20)
        padding 2px 6px
        font-size px2rem(26)
        color #fff
        font-weight normal
        line-height 1.4
        border-radius 4px
        background-color #13a0df

      .wraper-process
        padding-bottom px2rem(40)
        margin-left 13px

        .inner-process
          position relative
          border-left 1px solid #1d4a74
          padding-left px2rem(15)
          padding-bottom px2rem(50)
          &:last-child
            padding-bottom 0

          &:before
            content ''
            position absolute
            left px2rem(-7)
            width px2rem(12)
            height px2rem(12)
            border-radius 50%
            border px2rem(4) solid #13a0df

          .num
            position absolute
            margin-top px2rem(-10)
            font-size px2rem(26)
            color #13a0df
            font-weight 600

          .inner-title
            margin-top 0
            margin-bottom px2rem(10)
            padding-top px2rem(25)
            font-size px2rem(28)
            color #fff


</style>



// WEBPACK FOOTER //
// process.vue?70c05a7f